export const appSettingsTagsData = "/app_settings/tags_data";
